"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hot = void 0;
var hot = function (sourceModule, reactComponent) {
    return reactComponent;
};
exports.hot = hot;
//# sourceMappingURL=hot.prod.js.map